import * as zipCodeService from './zipCodeService'

export default zipCodeService
